<section *ngIf="open" class="ss-inline-panel" [attr.aria-label]="title">
  <header class="ss-inline-panel__header">
    <span *ngIf="icon" class="ss-inline-panel__icon" aria-hidden="true">
      <lucide-icon [name]="icon" [size]="18"></lucide-icon>
    </span>
    <h3 class="ss-inline-panel__title">{{ title }}</h3>
    <button type="button" class="ss-btn-icon ss-inline-panel__close" aria-label="Fechar" (click)="closed.emit()">
      <lucide-icon name="x" [size]="18" aria-hidden="true"></lucide-icon>
    </button>
  </header>
  <div class="ss-inline-panel__body">
    <ng-content></ng-content>
  </div>
  <footer class="ss-inline-panel__footer">
    <ng-content select="[ssPanelActions]"></ng-content>
  </footer>
</section>
